import React, { useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SideBarLoader from './SidebarLoader';

const CLOSE_DELAY_MS = 300;

const TopNav = ({ menu, loading, logo, siteUrl }) => {
    const location = useLocation();
    const [hoveredGroupIdx, setHoveredGroupIdx] = useState(null);
    const closeTimeoutRef = useRef(null);

    if (loading) return <SideBarLoader />;

    const clearCloseTimeout = () => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
    };

    const openGroup = (idx) => {
        clearCloseTimeout();
        setHoveredGroupIdx(idx);
    };

    const scheduleClose = () => {
        clearCloseTimeout();
        closeTimeoutRef.current = setTimeout(() => {
            setHoveredGroupIdx(null);
        }, CLOSE_DELAY_MS);
    };

    // routeGroupIdx only drives which top-level tab is highlighted as the
    // current section — it does NOT show row2 by itself. Row2 (the
    // sub-module strip) only appears while actively hovering a grouped item.
    const routeGroupIdx = menu.findIndex(item =>
        item.children?.some(c => c.to === location.pathname)
    );

    return (
        <div className="top-nav">
            <div className="top-nav-row1">
                <a className="top-nav-brand" href={siteUrl}>
                    {logo && <img src={logo} alt="Logo" />}
                </a>

                <ul className="top-nav-list">
                    {menu.map((item, idx) => {
                        if (!item.children) {
                            return (
                                <li
                                    key={idx}
                                    className={`top-nav-item ${location.pathname === item.to ? 'active' : ''}`}
                                    onMouseEnter={() => openGroup(-1)}
                                    onMouseLeave={scheduleClose}
                                >
                                    <Link to={item.to}>
                                        {item.icon && <i className={`mr-2 ${item.icon}`} />}
                                        {item.label}
                                    </Link>
                                </li>
                            );
                        }

                        return (
                            <li
                                key={idx}
                                className={`top-nav-item has-children ${(routeGroupIdx === idx || hoveredGroupIdx === idx) ? 'active' : ''}`}
                                onMouseEnter={() => openGroup(idx)}
                                onMouseLeave={scheduleClose}
                            >
                                <button type="button">
                                    {item.icon && <i className={`mr-2 ${item.icon}`} />}
                                    {item.label}
                                    <i className="fa fa-angle-down top-nav-caret" />
                                </button>

                                {hoveredGroupIdx === idx && (
                                    <div
                                        className="top-nav-row2"
                                        onMouseEnter={() => openGroup(idx)}
                                        onMouseLeave={scheduleClose}
                                    >
                                        <span className="top-nav-row2-label">{item.label}</span>
                                        <ul className="top-nav-row2-list">
                                            {item.children.map((child, cIdx) => (
                                                <li
                                                    key={cIdx}
                                                    className={location.pathname === child.to ? 'active' : ''}
                                                >
                                                    <Link to={child.to}>
                                                        {child.icon && <i className={`mr-2 ${child.icon}`} />}
                                                        {child.label}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default TopNav;
